import React from 'react';
import {
    View,
    Text,
    StyleSheet,
    Image,
} from 'react-native';
import { CartContext } from '../../contexts/cart/Store';
import { AuthContext } from '../../contexts/auth/Store';

import Config from '../../constants/Config';
import Colors from '../../constants/Colors'
import FontStyles from '../../constants/FontStyle';


export default function ({ borderColor, bgColor, textColor }) {
    const auth = React.useContext(AuthContext)
    const token = auth.getUserData.userToken
    const buyer = auth.getUserData.buyerData
    const [cart_state, cart_dispatch, cart_fetch] = React.useContext(CartContext)

    return cart_state && cart_state.order_group_items && cart_state.order_group_items.length
        ? <View
            style={[
                borderColor ? {
                    borderColor: borderColor+'4d',
                    borderWidth: 1,
                    borderStyle: 'solid',
                    borderRadius: 6,
                    padding: 16,
                    backgroundColor: bgColor || Colors.shades._3
                } : null
            ]}
        >
            <Text
                style={[
                    borderColor ? { color: borderColor } : FontStyles.dark,
                    FontStyles.size14,
                    FontStyles.lh18,
                    {
                        textAlign: 'center',
                        marginBottom: 11,
                    }
                ]}
            >You have {cart_state.order_group_items.length} product{`${cart_state.order_group_items.length > 1 ? 's' : ''}`} in your cart.</Text>

            <View style={{ flexDirection: 'row', justifyContent: 'center', }}>
                {
                    cart_state.order_group_items.slice(0, 4).reverse().map((item, i) => <View key={item._id} style={{ width: 38, height: 54 }}>
                        <Image
                            source={{ uri: `${Config.uploadUrl}/${item.product.upload.path}` }}
                            style={[
                                styles.image,
                                {
                                    borderColor: bgColor || Colors.whiteColor,
                                    marginLeft: -8, // offset to align center (54-38)/2
                                }
                            ]}
                        />
                    </View>)
                }
                {
                    (cart_state.order_group_items.length - 4 > 0) && <Text style={{ marginLeft: 20, alignSelf: 'center' }}>+{cart_state.order_group_items.length - 4}</Text>
                }
            </View>
        </View>
        : null
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    image: {
        width: 54,
        height: 54,
        borderRadius: 27,
        borderWidth: 3,
        backgroundColor: Colors.whiteColor
    }
});